<template>
  <b-card>
    <b-alert show variant="secondary">
      <h5 class="mb-1">{{ title }}</h5>
      <p class="mb-0">{{ message }}</p>
    </b-alert>
  </b-card>
</template>

<script>
// Placeholder de pestañas apagadas por flag (WhatsApp) o diferidas (Fase 5: taquizas,
// voz del cliente). No renderiza datos; sólo explica por qué está oculta/inactiva.
export default {
  name: 'ExecPlaceholder',
  props: {
    title: { type: String, default: 'Módulo no disponible' },
    message: { type: String, default: 'Esta sección se habilitará más adelante.' }
  }
}
</script>
